import { useEmbedManagerStore, type IDomain } from '@/stores/embeds/embedManager.store'
import axios from 'axios'

/**
 * check for valid domain
 * @param embedKey - The embed key
 * @param host - The host name
 * @returns Promise
 */
const checkForValidDomain = async (embedKey: string, host: string) => {
  const allowedDomains: string[] = [
    '127.0.0.1',
    'localhost',
    'www.jdoodle.com',
    'test.jdoodle.com',
    'dev.jdoodle.com',
    'dev01.jdoodle.com'
  ]
  const result = allowedDomains.find((domain: string) => {
    return host.includes(domain)
  })
  if (result) return true
  else {
    const payload = {
      embedKey: embedKey
    }
    return await axios
      .post('/api/embedDomain/queryDomainByEmbedKey', payload)
      .then((response: any) => {
        const result = response.data.find((domain: IDomain) => {
          return host.includes(domain.domain)
        })
        return result ? true : false
      })
      .catch(() => {
        throw new Error('Failed to check domain')
      })
  }
}
/**
 * add a domain
 * @param data - The domain
 * @returns Promise
 */
const addDomain = async (data: string) => {
  const payload = {
    domain: data,
    enabled: true
  }
  return await axios
    .post('/api/embedDomain/save', payload)
    .then((response: any) => {
      const domain = {
        id: response.data.id,
        domain: response.data.domain
      }
      useEmbedManagerStore().addDomain(domain)
    })
    .catch(() => {
      throw new Error('Failed to add domain')
    })
}
/**
 * remove a domain
 * @param id - The domain id
 * @returns Promise
 */
const removeDomain = async (id: number) => {
  const payload = {
    id: id
  }
  return await axios
    .post('/api/embedDomain/delete', payload)
    .then(() => {
      const domains = useEmbedManagerStore().getDomains
      const index = domains.findIndex((domain: IDomain) => domain.id === id)
      domains.splice(index, 1)
    })
    .catch(() => {
      throw new Error('Failed to delete domain')
    })
}
export default {
  checkForValidDomain,
  addDomain,
  removeDomain
}
